import React, { useMemo, useState } from 'react';
import HighRiskKeywordsModal from './HighRiskKeywordsModal';
import Keyword from './Keyword';
import { buildKeywordData } from './detectionTypeUtils';

import { ReactComponent as ExpandIcon } from '../../../assets/icons/expand.svg';

const HighRiskCard = ({site}) => {
  const [modalVisible, setModalVisible] = useState(false);
  const data = useMemo(() => buildKeywordData(site.data), [site.data]);
  const canExpand = data.length > 0;

  return (
    <div className="gradient keywords">
      {modalVisible && canExpand && (
        <HighRiskKeywordsModal data={data} setVisible={setModalVisible} />
      )}
      <div className="keywords__header">
        <h4 className="margin-none section-accent-title section-accent-title--warning">High Risk Keywords</h4>
        {canExpand && (
          <button
            type="button"
            className="control-btn traffic-graph__expand-btn"
            aria-label="Expand high risk keywords"
            onClick={() => setModalVisible(true)}
          >
            <ExpandIcon className='icon sm image' />
          </button>
        )}
      </div>

      <div className="keyword-container">
        {data.map((keyword) => {
          return (
            <Keyword
              key={keyword.text}
              text={keyword.text}
              number={keyword.number}
              riskLevel={keyword.riskLevel}
            />
          );
        })}
        {data.length === 0 && (
          <p className="empty-state margin-none">No high risk keywords available.</p>
        )}
      </div>
    </div>
  );
}

export default HighRiskCard;
